module.exports = __webpack_public_path__ + "img/img-bccc42.png";